import React, { useEffect } from "react";
import css from './Sections.module.css';
import { Avatar, Carousel } from 'antd';
import { fetchAllBlogs, getBlogsSelector, getBlogsInProgress, fetchAllFaqs, getFaqsSelector, getFaqsInProgress } from "../../../../ducks/strapi.duck";
import { useDispatch, useSelector } from "react-redux";
import { useConfiguration } from "../../../../context/configurationContext";
import { useLocation } from "react-router-dom";
import { parse } from "../../../../util/urlHelpers";
import { NamedLink } from "../../../../components";
import { createResourceLocatorString } from "../../../../util/routes";
import { convertStrapiRichTextToReact, extractPlainTextFromStrapiRichText } from "../../../../util/richTextHelpers";
import { convertMarkdownToReact } from "../../../../util/markdownHelpers";

const baseUrl = process.env.REACT_APP_STRAPI_BASE_URL;

const truncateText = (text, maxLength) => {
  if (!text) return '';
  const stringText = String(text);
  return stringText.length > maxLength ? `${stringText.slice(0, maxLength)}...` : stringText;
};

const getImagesLink = (images, url) => {
  // Generate an array of image URLs using the base URL and the image object's URL attribute.
  const imageUrls =
    isArrayLength(images) &&
    images.map(image => {
      const imageUrl = `${url}${image?.attributes?.url}`;
      return imageUrl;
    });

  // Return the array of image URLs.
  return imageUrls;
};

const isArrayLength = arr => {
  // Check if the input parameter is an array and has a length greater than zero.
  return Array.isArray(arr) && (arr.length > 0 ?? false);
};

function SectionBlogs(props) {
  const { history, routeConfiguration } = props;

  const dispatch = useDispatch();
  const config = useConfiguration();
  const location = useLocation();

  const search = parse(location.search);
  const currentTag = search?.tag;

  // Get data from Redux store
  const blogsData = useSelector(getBlogsSelector) || [];
  const isLoading = useSelector(getBlogsInProgress);

  let top4Blogs = blogsData.slice(0, 4) || [];

  // Fixed useEffect - removed async and await
  useEffect(() => {
    dispatch(fetchAllBlogs({ tag: search?.tag }));
  }, [dispatch, search?.tag]);

  // Show loading state if needed
  if (isLoading) {
    return (
      <div className={css.blogSection}>
        <div className={css.fixedWidthContainer}>
          <div className={css.blogHeader}>
            <h2>Our Blogs</h2>
          </div>
          <div>Loading blogs...</div>
        </div>
      </div>
    );
  }

  // Handle empty state
  if (!blogsData || blogsData.length === 0) {
    return (
      <div className={css.blogSection}>
        <div className={css.fixedWidthContainer}>
          <div className={css.blogHeader}>
            <h2>Our Blogs</h2>
          </div>
          <div>No blogs available at the moment.</div>
        </div>
      </div>
    );
  }
  
return (
    <div className={css.blogSection}>
      <div className={css.fixedWidthContainer}>
        <div className={css.blogHeader}>
          <h2>Our Blogs</h2>
          {/* <a href="/blogs">Read all</a> */}
          <NamedLink className={css.link} name="BlogPage">
            Read all
          </NamedLink>
        </div>

        <div className={css.inDesktop}>
          <div className={css.blogList}>
            {top4Blogs.map((blog) => {

              const rawDescription = blog?.description || blog?.attributes?.description;
  
              // Extract plain text for meta description
              let descriptionText = '';
              let descriptionContent = null;

              if (Array.isArray(rawDescription)) {
                // It's Strapi rich text format
                descriptionText = extractPlainTextFromStrapiRichText(rawDescription);
                descriptionContent = convertStrapiRichTextToReact(rawDescription);
              } else if (typeof rawDescription === 'string') {
                // It's markdown or plain text
                descriptionText = rawDescription;
                descriptionContent = convertMarkdownToReact(rawDescription);
              }

              return (
                <NamedLink key={blog?.id} className={css.blog} style={{ color: 'black', textDecoration: 'none' }} name="SingleBlogPage" params={{ title: blog?.attributes?.slug || blog?.slug || 'blog-title'}}>
                  <div className={css.blogCard} >
                    <div className={css.blogImg}>
                      {/* Updated to handle the attributes structure like BlogPage */}
                      {blog?.coverImage?.formats?.small?.url || blog?.coverImage?.formats?.medium?.url || blog?.coverImage?.url || blog?.coverImage?.formats?.thumbnail?.url || blog?.attributes?.coverImage?.data?.attributes?.url ? (
                        <img
                          src={blog?.coverImage?.formats?.small?.url || blog?.coverImage?.formats?.medium?.url || blog?.coverImage?.url || blog?.coverImage?.formats?.thumbnail?.url || blog?.attributes?.coverImage?.data?.attributes?.url}
                          alt={blog?.title}
                          className={css.blogCoverImage}
                        />
                      ) : (
                        <div className={css.noImagePlaceholder}>No image</div>
                      )}
                    </div>
                    <div className={css.blogTitle}>
                      <h6>{String(blog?.attributes?.category || blog?.attributes?.tag || blog?.category || blog?.tag || '')}</h6>
                      <h5>{String(blog?.title || blog?.attributes?.title || '')}</h5>
                    </div>
                    <div className={css.blogContent}>
                      <div className={css.blogAuthor} style={{ fontSize: '14px' }}>
                        
                        {(blog?.attributes?.author?.avatar || 
                            blog?.attributes?.author?.profile_image || 
                            blog?.author?.avatar || 
                            blog?.author?.profile_image) ? (
                              <Avatar 
                                src={
                                  blog?.attributes?.author?.avatar || 
                                  blog?.attributes?.author?.profile_image || 
                                  blog?.author?.avatar || 
                                  blog?.author?.profile_image
                                } 
                              />
                            ) : (
                              <Avatar size={30}>{String(blog?.author?.username?.charAt(0)?.toUpperCase() || 'A')}</Avatar>
                            )}
                        <em>
                          {String(
                            (blog?.author?.username?.charAt(0)?.toUpperCase() + blog?.author?.username?.slice(1)) ||
                            blog?.attributes?.author?.name ||
                            blog?.attributes?.author_name ||
                            blog?.author?.name ||
                            blog?.author_name ||
                            blog?.attributes?.author?.data?.attributes?.username || 'Anonymous'
                          )}
                        </em>
                      </div>
                      {/* <p>
                        {blog?.attributes?.excerpt || 
                        blog?.attributes?.description || 
                        blog?.attributes?.summary || 
                        blog?.excerpt || 
                        blog?.description || 
                        blog?.summary}
                      </p> */}
                      <p className={css.blogPostDescription}>
                        {truncateText(descriptionText, 150)}
                      </p>
                    </div>
                  </div>
                  </NamedLink>
              )
            })}
          </div>
        </div>

        <div className={css.inMobile}>
          <div className={css.blogList}>
            <Carousel autoplay>
              {top4Blogs.map((blog) => {
                const rawDescription = blog?.description || blog?.attributes?.description;
  
                // Extract plain text for meta description
                let descriptionText = '';
                let descriptionContent = null;

                if (Array.isArray(rawDescription)) {
                  // It's Strapi rich text format
                  descriptionText = extractPlainTextFromStrapiRichText(rawDescription);
                  descriptionContent = convertStrapiRichTextToReact(rawDescription);
                } else if (typeof rawDescription === 'string') {
                  // It's markdown or plain text
                  descriptionText = rawDescription;
                  descriptionContent = convertMarkdownToReact(rawDescription);
                }
                
                return (
                  <NamedLink key={blog?.id} className={css.blog} name="SingleBlogPage" params={{ title: blog?.attributes?.slug || blog?.slug || 'blog-title'}}>
                    <div className={css.blogCard} >
                      <div className={css.blogImg}>
                        {blog?.coverImage?.formats?.small?.url || blog?.coverImage?.formats?.medium?.url || blog?.coverImage?.url || blog?.coverImage?.formats?.thumbnail?.url || blog?.attributes?.coverImage?.data?.attributes?.url ? (
                          <img
                            src={blog?.coverImage?.formats?.small?.url || blog?.coverImage?.formats?.medium?.url || blog?.coverImage?.url || blog?.coverImage?.formats?.thumbnail?.url || blog?.attributes?.coverImage?.data?.attributes?.url}
                            alt={blog?.title}
                            className={css.blogCoverImage}
                          />
                        ) : (
                          <div className={css.noImagePlaceholder}>No image</div>
                        )}

                      </div>
                      <div className={css.blogTitle}>
                        <h6>{String(blog?.attributes?.category || blog?.attributes?.tag || blog?.category || blog?.tag || '')}</h6>
                        <h5>{String(blog?.title || blog?.attributes?.title || '')}</h5>
                      </div>
                      <div className={css.blogContent}>
                        <div className={css.blogAuthor} style={{ fontSize: '14px' }}>
                          {(blog?.attributes?.author?.avatar || 
                            blog?.attributes?.author?.profile_image || 
                            blog?.author?.avatar || 
                            blog?.author?.profile_image) ? (
                              <Avatar 
                                src={
                                  blog?.attributes?.author?.avatar || 
                                  blog?.attributes?.author?.profile_image || 
                                  blog?.author?.avatar || 
                                  blog?.author?.profile_image
                                } 
                              />
                            ) : (
                              <Avatar size={30}>{String(blog?.author?.username?.charAt(0)?.toUpperCase() || 'A')}</Avatar>
                            )}
                          <em>
                            {String(
                              (blog?.author?.username?.charAt(0)?.toUpperCase() + blog?.author?.username?.slice(1)) ||
                              blog?.attributes?.author?.name ||
                              blog?.attributes?.author_name ||
                              blog?.author?.name ||
                              blog?.author_name ||
                              blog?.attributes?.author?.data?.attributes?.username || 'Anonymous'
                            )}
                          </em>
                        </div>
                        {/* <p>
                          {blog?.attributes?.excerpt || 
                          blog?.attributes?.description || 
                          blog?.attributes?.summary || 
                          blog?.excerpt || 
                          blog?.description || 
                          blog?.summary}
                        </p> */}
                        <p className={css.blogPostDescription}>
                          {truncateText(descriptionText, 150)}
                        </p>
                      </div>
                    </div>
                    </NamedLink>
                )
              })}
            </Carousel>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SectionBlogs;